import { url } from "../Common/common"; 

/**
 * getOrders(pars, callback)
 * pars: { user_id, date_start, date_end }
 * callback: function(data)
 */
export function getOrders(pars, callback) {
  const formData = new FormData();
  if (pars.date_start !== undefined) formData.append('date_start', pars.date_start);
  if (pars.date_end !== undefined) formData.append('date_end', pars.date_end);
  if (pars.user_id !== undefined) formData.append('user_id', pars.user_id);

  fetch(url + '/getstatorders', {
    method: 'POST',
    // mode: 'no-cors' -- УБРАЛ, потому что no-cors мешает получать JSON-ответ.
    body: formData,
    // credentials: 'include', // если нужно
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.status);
      }
      return response.json();
    })
    .then((data) => {
      callback(data);
    })
    .catch((err) => {
      console.error('getOrders error', err);
      callback({ orders: [] });
    });
}

/**
 * getTechnics(pars, callback)
 * pars: { user_id }
 * callback: function(data)
 */
export function getTechnics(pars, callback) {
  const formData = new FormData();
  if (pars.user_id !== undefined) formData.append('user_id', pars.user_id);

  fetch(url + '/gettechnics', {
    method: 'POST',
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.status);
      }
      return response.json();
    })
    .then((data) => {
      callback(data);
    })
    .catch((err) => {
      console.error('getTechnics error', err);
      callback({ technics: [] });
    });
}
